import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Hero from '../components/Hero/Hero';
import UltimiArticoli from '../components/UltimiArticoli/UltimiArticoli';
import Footer from '../components/Footer/Footer';

const Home = ({pagesLeft,pagesRight,articles}) => {
    return (
        <div>
            <Navbar pagesLeft={pagesLeft} pagesRight={pagesRight}></Navbar>
            <Hero></Hero>
            <UltimiArticoli articles={articles}></UltimiArticoli>
            <Footer></Footer>
        </div>
    )
}

export default Home